// Port of api/fuel/app/classes/filter/search/games/filters/query/play/unplayed.php
export default {
	name: 'play.unplayed',
	priority: 55,
	require: function(config, filter) {
		return filter.unplayed === 1
	},
	run: function(config, filter, data, query) {
		query.notexist('play', 'p')
	}
}
